var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"singleImage grid grid__item_span-12 p0 m0"},[_c('img',{attrs:{"src":_vm.item.project_single_image.url,"alt":_vm.item.project_single_image.alt,"title":_vm.item.project_single_image.title}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba25c23","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/singleImage.vue
// module id = null
// module chunks = 